<div class="time-widget">
  <div class="title-area">
    <div class="title">
      {{ 'COMMUNICATIONS.RESPONSES-OVER-TIME' | translate }}
    </div>
  </div>
  <div>
    <topo-bar-chart
      [width]="width"
      [height]="'300px'"
      [types]="barTypes"
      [colors]="colors"
      [countLabel]="countLabel"
      [dataLabel]="dataLabel"
      [colorPerBar]="false"
      [horizontal]="false"
      [xGap]="xGap"
      [data]="data"
      (select)="selected($event)"></topo-bar-chart>
  </div>
</div>
